<template>
    
  <div id="listMeses">
    <v-sheet style="margin-left: 25px;">
        <v-switch
          v-model="exibirSomenteAbertos"
          inset
          color="#2A5377"
          :label="`Exibir somente abertos`"
        ></v-switch>
      </v-sheet>        
    <v-layout v-resize="onResize" style="display:flex;flex-flow: column;">
      <v-container
        v-if="loadinData"
        style="height: 400px;display: flex;margin-top:150px; justify-content: center;"
      >
        <v-row class="fill-height" align-content="center" justify="center">
          <v-col class="subtitle-1 text-center" cols="12">Baixando dados..</v-col>
          <v-col cols="6">
            <v-progress-linear color="#88C658" indeterminate rounded height="6"></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
      <div v-else>        
        <v-data-table
          :headers="headers"
          rows-per-page-text="Items por página"
          :items="arquivosArr"
          :hide-headers="isMobile"
          :class="{mobile: isMobile}"
          item-key="MESANO"
          :pagination.sync="pagination"
          no-data-text="Nada foi encontrado."
          no-results-text="Nada foi encontrado."
          :search="search"
          style="width: 100%!important;"
          :sort-by="['MESANO']"
          :sort-desc="[true]"
          multi-sort
          :rows-per-page-items="[
              {
                text: '100',
                value: 100
              },
              {
                text: '300',
                value: 300
              },
              {
                text: '500',
                value: 500
              },
              {
                text: 'Todos',
                value: -1
              }
            ]"
        >
          <template v-slot:items="props">
            <tr v-if="!isMobile">
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.ANO || "---" }}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.MES || "---" }}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.ENVIADOS || "---"}}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.BAIXADOS || "---"}}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.PAGOS || "---"}}</td>              
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.TOTAL || "---" }}</td>
            </tr>
            <tr v-else>
              <td style="margin-bottom:25px">
                <ul class="flex-content">
                  <li class="flex-item" data-label="Ano:">{{ props.item.ANO }}</li>
                  <li class="flex-item" data-label="Mês:">{{ props.item.MES }}</li>
                  <li class="flex-item" data-label="Enviados:">{{ props.item.ENVIADOS }}</li>
                  <li class="flex-item" data-label="Baixados:">{{ props.item.BAIXADOS }}</li>
                  <li class="flex-item" data-label="Pagos:">{{ props.item.PAGOS }}</li>
                  <li class="flex-item" data-label="Total:">{{ props.item.TOTAL }}</li>
                </ul>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              style="color: #000!important"
            >Nada foi encontrado.</v-alert>
          </template>

          <template v-slot:expand="props" v-if="!isMobile">
            <DetalhesBoleto :mesano="props.item" :exibirSomenteAbertos="exibirSomenteAbertos" />
          </template>

          <template
            slot="pageText"
            slot-scope="item"
          >Exibindo {{item.pageStart}} - {{item.pageStop}}, Total {{item.itemsLength}}</template>
        </v-data-table>
      </div>
    </v-layout>

    <md-snackbar :md-active.sync="empSaved">Sucesso!</md-snackbar>
    <md-snackbar :md-active.sync="errorSaved">Erro interno do servidor</md-snackbar>
    <md-snackbar :md-active.sync="msg">{{msg}}</md-snackbar>
  </div>
</template>
<script>
import * as Boletos from "../../providers/boletos.service";
import DetalhesBoleto from "./detalhesBoleto";

var jwt = require("jsonwebtoken");

export default {
  name: "tabela-boletos",
  components: {
    Map,
    DetalhesBoleto
  },
  data() {
    return {
      isMobile: false,
      search: "",
      loadinData: true,
      loading5: false,
      msg: false,
      exibirObsoletos: false,
      pagination: { rowsPerPage: 100 },
      errorSaved: false,
      empSaved: false,
      arquivosArr: [],
      exibirSomenteAbertos: false,
      headers: [
        {
          text: "Ano",
          value: "ANO"
        },
        {
          text: "Mês",
          value: "MES"
        },
        {
          text: "Enviados",
          value: "ENVIADOS"
        },       
        {
          text: "Baixados",
          value: "BAIXADOS"
        },       
        {
          text: "Pagos",
          value: "PAGOS"
        },
        {
          text: "Total",
          value: "TOTAL"
        }
      ],
      desserts: []
    };
  },

  methods: {    
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    findData() {
      var self = this;

      var fUser = jwt.decode(localStorage.getItem("token"));
  
      Boletos.getMesesBoleto().then(resp => {
        self.arquivosArr = resp;
        self.loadinData = false;
      });
    },   
  },
  created() {
    var self = this;
    self.exibirObsoletos = false;
    self.findData();
  }
};
</script>
<style scoped>
.copy {
  position: relative;
}
.copy .iconcopy {
  opacity: 0;
  position: absolute;
  color: rgb(97, 97, 97);
  top: 0;
}
.copy:hover .iconcopy {
  opacity: 1;
  cursor: pointer;
}
li {
  min-height: 58px;
}
.iconedit {
  font-size: 15px !important;
  position: absolute;
  top: 5px;
  right: 5px;
  opacity: 0;
  cursor: pointer;
}
.descarrude:hover .iconedit {
  opacity: 1;
}
.iconedit:hover {
  font-size: 16px !important;
  position: absolute;
  color: #000 !important;
  top: 5px;
}
</style>
<style>
#listAarquios .v-datatable__actions__select {
  opacity: 0;
  display: none !important;
}
</style>